'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { withDemoMode } from '@/lib/network';
import { useUserNetwork } from '@/lib/network/client';
import { ShareModal } from '@/lib/share';
import { cn } from '@/lib/ui/utils';
interface ProposalShareButtonProps {
  proposalPubkey: string;
  proposalTitle: string;
  className?: string;
  /** Forwarded to the trigger button. Use to stop propagation when the
   *  button lives inside a clickable row (the launchpad list view). */
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
export function ProposalShareButton(t0) {
  const $ = _c(27);
  const {
    proposalPubkey,
    proposalTitle,
    className,
    onClick
  } = t0;
  const t = useTranslations("launchpad.share");
  const {
    network
  } = useUserNetwork();
  let t1;
  bb0: {
    if (typeof window === "undefined") {
      t1 = "";
      break bb0;
    }
    let t2;
    if ($[0] !== network || $[1] !== proposalPubkey) {
      const u = new URL(`/proposals/${proposalPubkey}`, window.location.origin);
      withDemoMode(u, network === "mainnet" ? "mainnet" : "devnet");
      t2 = u.toString();
      $[0] = network;
      $[1] = proposalPubkey;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const url = t1;
  let t2;
  if ($[3] !== proposalPubkey) {
    t2 = {
      kind: "proposal",
      proposalPubkey
    };
    $[3] = proposalPubkey;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== proposalTitle || $[6] !== t) {
    t3 = t("tweetText", {
      proposalTitle
    });
    $[5] = proposalTitle;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("modalTitle");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("button");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== className) {
    t6 = cn("shrink-0 h-8 bg-background-tertiary", className);
    $[12] = className;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("button");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== onClick || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <AnimatedButton variant="tertiary" size="sm" aria-label={t5} className={t6} onClick={onClick}>{t7}</AnimatedButton>;
    $[16] = onClick;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t8 || $[25] !== url) {
    t9 = <ShareModal surface={t2} url={url} text={t3} title={t4} trigger={t8} />;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t8;
    $[25] = url;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}